export interface SearchDashboardAPIParams {
  searchDate?: SearchDate;
  brands?: string[];
  isPreRequest?: boolean;
  b2bRestricted?: boolean;
  limit?: number;
  requestId?: string;
}

export interface SearchDate {
  date?: Date;
  start?: Date;
  end?: Date;
}

export interface AgendaDashboardAPIParams {
  searchDate?: SearchDate;
  fitterIds?: string[];
}

export interface SuperAdminStatisticsAPIParams {
  searchDate?: SearchDate;
  insurers?: { id: string; hasFitterCount: boolean }[];
  isPreRequest?: boolean;
  limit?: number;
  requestId?: string;
}
export interface SuperAdminSmsStatisticsAPIParams {
  start: string;
  end: string;
  configId: string;
}
